import * as m from "mithril";
import './OutlineButton.css'

interface Attrs{
    id?: string,
    label:string,
    icon:string,
    selected:any,
    onSelected:()=>void
}

function OutlineButton():m.Component<Attrs> {
return{
    view(vnode) {
        
        return m("div", {
            class:  (vnode.attrs.selected) ? 
                "outlineButton bg-secondary text-white d-flex align-items-center" : "outlineButton bg-white d-flex align-items-center",
            id: (vnode.attrs.id)? vnode.attrs.id : null,
            type: "button",
            style: "border-radius:40px; padding:4px 12px; border:1px solid rgba(0, 0, 0, 0.125);",
            onclick: vnode.attrs.onSelected
        },
            [
                // m("i", { class: (vnode.attrs.selected) ? vnode.attrs.icon + " text-white": vnode.attrs.icon + " text-info", style: "font-size:12px" }),
                m("span", {
                    // class: "pl-1",
                    style: "font-size:14px" }, vnode.attrs.label)
            ])
    }
}
}

export default OutlineButton;
